import React, { useState, useRef } from "react";
import {
  IconButton,
  Tooltip,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
} from "@mui/material";
import { UploadFile, CheckCircle, WarningAmber } from "@mui/icons-material";
import api from "../../api";

export default function SondaLabUploadButton({ jobId, onUploadSuccess }) {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const fileInputRef = useRef(null);

  const [openModal, setOpenModal] = useState(false);
  const [warnings, setWarnings] = useState([]);
  const [updatedCount, setUpdatedCount] = useState(0);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setLoading(true);
    setSuccess(false);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("jobId", jobId);

    try {
      // YENİ VE FARKLI SADECE SONDAYA ÖZEL ENDPOINT
      const res = await api.post(`/admin/upload-lab-sonda/${jobId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        setSuccess(true);
        if (onUploadSuccess) onUploadSuccess();

        const count = res.data.updatedCount || 0;
        setUpdatedCount(count);

        if (res.data.warnings && res.data.warnings.length > 0) {
          setWarnings(res.data.warnings);
          setOpenModal(true);
        } else {
          alert(`Sonda Başarılı! Toplam ${count} kayıt güncellendi.`);
        }
      }
    } catch (err) {
      console.error("Sonda Lab yükleme hatası:", err);
      alert(
        "Yükleme başarısız: " + (err.response?.data?.message || err.message),
      );
    } finally {
      setLoading(false);
      setTimeout(() => setSuccess(false), 3000);
    }
  };

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept=".xlsx, .xls, .csv"
        onChange={handleFileChange}
      />

      <Tooltip title="Sondalar için Lab Verisi Yükle (Excel)">
        <IconButton
          color={success ? "success" : "secondary"}
          onClick={handleButtonClick}
          disabled={loading}
          sx={{
            mr: 1,
            color: success ? "green" : "#9c27b0",
            bgcolor: loading ? "transparent" : "rgba(156, 39, 176, 0.1)",
            "&:hover": { bgcolor: "rgba(156, 39, 176, 0.2)" },
          }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : success ? (
            <CheckCircle />
          ) : (
            <UploadFile />
          )}
        </IconButton>
      </Tooltip>

      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "warning.main",
            fontWeight: "bold",
          }}
        >
          <WarningAmber /> Sonda Yüklemesi Başarılı Ancak Bazı Uyuşmazlıklar
          Tespit Edildi!
        </DialogTitle>
        <DialogContent dividers>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 2,
              p: 1.5,
              bgcolor: "rgba(156, 39, 176, 0.1)",
              borderRadius: 1,
            }}
          >
            <CheckCircle color="secondary" fontSize="small" />
            <Typography
              variant="body1"
              sx={{ color: "secondary.main", fontWeight: "bold" }}
            >
              Toplam {updatedCount} sonda verisi başarıyla eşleşti ve
              güncellendi.
            </Typography>
          </Box>

          <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
            Laboratuvar verileri SONDALAR için sisteme aktarıldı. Ancak
            aşağıdaki satırlarda laboratuvar sonuçlarıyla hesaplanan bünye
            sınıfı (Tekstür) uyuşmuyor veya Kum, Silt, Kil toplamı hatalı.
            Sistem doğru olan hesaplanan değeri kaydetti.
          </Typography>
          <List dense>
            {warnings.map((warn, index) => (
              <ListItem
                key={index}
                sx={{
                  bgcolor: "rgba(237, 108, 2, 0.05)",
                  mb: 1,
                  borderRadius: 1,
                }}
              >
                <ListItemIcon
                  sx={{ minWidth: 48, display: "flex", alignItems: "center" }}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "bold", mr: 1, color: "warning.main" }}
                  >
                    {index + 1}.
                  </Typography>
                  <WarningAmber fontSize="small" color="warning" />
                </ListItemIcon>
                <ListItemText primary={warn} />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenModal(false)}
            variant="contained"
            color="primary"
          >
            Anladım, Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
